export default "__VITE_ASSET__EfyEERDR__"